import React from 'react';
import { TabState } from '../../../../types';
import { SQLQueryInfo } from '../../information-viewers/SQLQueryInfo';
import { usePaneLayout } from '../../../stores/hooks/usePaneLayout';
import * as styles from './SQLQueryViewerTabContent.css.ts';

interface SQLQueryViewerTabContentProps {
  tab: TabState;
}

/**
 * SQLQueryViewerTabContent
 *
 * SQLクエリを表示する専用タブ
 */
export const SQLQueryViewerTabContent: React.FC<SQLQueryViewerTabContentProps> = ({ tab }) => {
  const paneLayout = usePaneLayout();
  const datasetId = tab.metadata?.datasetId;

  if (!datasetId) {
    return (
      <div className={styles.container}>
        <div className={styles.error}>
          <h3>Dataset ID Missing</h3>
          <p>No dataset ID was provided for SQL query view.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <SQLQueryInfo
        datasetId={datasetId}
        onClose={() => {
          const activeContainerId = paneLayout.layout.activeContainerId;
          if (activeContainerId) {
            paneLayout.closeTab(activeContainerId, tab.id);
          }
        }}
      />
    </div>
  );
};